import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

/**
 * Initialise Animate-On-Scroll once, refresh whenever the route changes
 * (so newly-mounted elements pick up their data-aos attributes).
 * Respects the user's reduced-motion preference.
 */
export function AosController() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const reduce = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    AOS.init({
      duration: 600,
      easing: 'ease-out-cubic',
      once: true,
      offset: 40,
      disable: reduce ? 'phone' : false,
    });
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    // Defer to next tick so the new route's DOM has mounted.
    const t = window.setTimeout(() => AOS.refreshHard(), 80);
    return () => window.clearTimeout(t);
  }, [location.pathname]);

  return null;
}
